import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

import { LOCALE } from '../../env';
import hero1 from '../../../public/images/avatars/hero1_conv.png';
import hero2 from '../../../public/images/avatars/hero2_conv.png';
import hero3 from '../../../public/images/avatars/hero3_conv.png';
import hero3ad from '../../../public/images/avatars/hero3_ad.png';
import heroine1 from '../../../public/images/avatars/heroine1_conv.png';
import heroine2 from '../../../public/images/avatars/heroine2_conv.png';
import heroine3 from '../../../public/images/avatars/heroine3_conv.png';
import heroine3ad from '../../../public/images/avatars/heroine3_ad.png';

const items = [
  { id: 'hero1_conv', imageSrc: hero1 },
  { id: 'hero2_conv', imageSrc: hero2 },
  { id: 'hero3_conv', imageSrc: (LOCALE === 'gh') ? hero3ad : hero3 },
  { id: 'heroine1_conv', imageSrc: heroine1 },
  { id: 'heroine2_conv', imageSrc: heroine2 },
  { id: 'heroine3_conv', imageSrc: (LOCALE === 'gh') ? heroine3ad : heroine3 },
];

const renderAvatar = (imgSrc, SelectId, checked, handleChangeAvatar) => {
  const inputId = `selected_avatar_id_${SelectId}`;
  return (
    <Grid item xs={12} md={2} className="avatar_box" key={SelectId}>
      <input type="radio" name="avatarFileName" id={inputId} value={SelectId} checked={checked} onChange={handleChangeAvatar} />
      <label className="avatar" htmlFor={inputId}>
        <img src={imgSrc} alt="avatar" />
      </label>
    </Grid>
  );
};

const Avatars = ({ selectedAvatar, handleChangeAvatar }) => {
  return (
    <Grid container spacing={1} className="avatar-select" >
      {items.map((i) => {
        return renderAvatar(i.imageSrc, i.id, i.id === selectedAvatar, handleChangeAvatar);
      })}
    </Grid>
  );
};

Avatars.propTypes = {
  selectedAvatar: PropTypes.string.isRequired,
  handleChangeAvatar: PropTypes.func.isRequired,
};

export default Avatars;
